















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Service as ServiceInterface } from "../../services/service/entities/service.interface";

@Component
export default class Service extends Vue {
  @Prop() service!: ServiceInterface;
}
